import React from "react";

function MorqueSlider() {
  const spanArray = Array.from(Array(100).keys());

  return (
    <div className="border-b-[1px] marquee-container">
      <div className="p-1 font-primaryFont text-primary marquee">
      {spanArray.map((index) => (
        <span key={index} className="Dbxihgns">
          Free Shipping
        </span>
      ))}
      </div>
    </div>
  );
}

export default MorqueSlider;
